import { makeStyles, shorthands } from '@fluentui/react-components';
import {
  getSharedAssetContainerStyle,
  getSharedMultiSelectingCellStyles,
} from '../shared-cell-style';

export const useVideoAssetsGridCellStyle = makeStyles({
  VideoAssetsGridCellContainer: {
    ...getSharedAssetContainerStyle(),
  },

  videoCellLabelContainer: {
    display: 'flex',
    position: 'absolute',
    left: '12px',
    bottom: '8px',
    zIndex: 1,
  },

  videoCell: {
    // visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    top: '0px',
    left: '0px',
    // zIndex: -1,
    ...shorthands.borderRadius('6px'),
    '& .video-previewer-root': {
      backgroundColor: 'transparent',
      transform: 'translateY(-100%)',
      '& .time': {
        paddingLeft: '8px',
        paddingRight: '12px',
        color: '#fff',
        fontSize: '11px',
        lineHeight: '14px',
        whiteSpace: 'nowrap',
      },
      '& button[aria-label="Unmute"], button[aria-label="Mute"]': {
        marginRight: '8px',
        '& .ms-Icon': {
          lineHeight: '32px',
          fontSize: '32px',
          height: '32px',
        },
      },
    },
    '&.show-video': {
      // visibility: 'visible',
      opacity: 1,
      // zIndex: 2,
    },
  },
  placeholderCell: {
    width: '100%',
    height: '135px',
  },

  // only show checkbox on overlay if it is NOT in multi-selecting mode
  ...getSharedMultiSelectingCellStyles(),
});
